export default __webpack_public_path__ + "static/media/icon-chip.0d40cfb1.svg";